/**
 * @module modalPopupBox
 */

/**
 * @param {Cookie} Cookies   - Object from Cookies-module
 * @param {Object} container - object with modalBox elements
 */

module.exports = function( Cookies, container ) {
    const cookieName = 'Hide_modal';
    const cfID = container.closest( '.wpcf7' ).attr( 'id' );
    $( document ).on( 'hide.bs.modal', container, function( e ) {
        Cookies.create( cookieName, '1', '30d' );
        container.remove();
    } );
    container.modal( 'show' );
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        if ( cfID === event.detail.id ) {
            const userEmail = $( event.target ).find( '[type=email]' ).val();
            if ( userEmail.length > 0 && typeof __insp === 'object' ) {
                __insp.push( [ 'identify', userEmail ] );
            }
            $( event.target ).find( '#modal-form-message' ).addClass( 'd-block' ).removeClass( 'd-none' );
            $( event.target ).find( '#modal-form-content' ).remove();
            $( event.target ).find( '.modal-title' ).addClass( 'd-none' );
        }
    }, false );
}; // exports

